import React from 'react';
import { useActiveTooltipLabel } from 'recharts';

/** Reports the Recharts active category (mouse or keyboard) to its owner. */
export const ActiveLabelReporter: React.FC<{ onChange: (label: string | undefined) => void }> = ({
  onChange,
}) => {
  const label = useActiveTooltipLabel();
  React.useEffect(() => {
    onChange(label === undefined || label === null ? undefined : String(label));
  }, [label, onChange]);
  return null;
};
